import { render } from "./ProductPattern.vue?vue&type=template&id=ddf270da&scoped=true"
import script from "./ProductPattern.vue?vue&type=script&lang=js"
export * from "./ProductPattern.vue?vue&type=script&lang=js"

import "./ProductPattern.vue?vue&type=style&index=0&id=ddf270da&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ddf270da"]])

export default __exports__